import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-alabaster px-6 text-center">
          <div>
            <p className="font-serif text-3xl text-navy">Si è verificato un errore</p>
            <p className="mt-3 text-sm text-muted-ink">Ricarica la pagina per continuare la navigazione.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
